import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'saheeh_language',
      caches: ['localStorage'],
    },
  });

// Keep <html dir> in sync with current language so RTL kicks in for Arabic.
const applyDir = (lng: string) => {
  const isRtl = (lng || 'en').toLowerCase().startsWith('ar');
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.lang = isRtl ? 'ar' : 'en';
};
applyDir(i18n.language);
i18n.on('languageChanged', applyDir);

export default i18n;
